'use client';

import React from 'react';
import RootLayouts from '@/layouts/Rootlayouts';

import ExploreCourseLevel from '@/components/course/ExploreCourseLevel';
import ExploreCoursesByStream from '@/components/course/ExploreCoursesByStream';

const CoursePageComponent = ({ streams, courseLevel }: any) => {
  return (
    <RootLayouts>
      <section className="mt-24 lg:mt-28">
        <ExploreCoursesByStream streamData={streams} />
        <ExploreCourseLevel courseLevelData={courseLevel} />
      </section>
    </RootLayouts>
  );
};

export default CoursePageComponent;
